/**
 * @Description 图片展示区域
 */

import { FC, useState } from 'react';
import { Image } from 'antd';
import IconFont from '@/common/components/IconFont';
import { getQiniuOriginalUrl } from '@/common/utils/image';
import styles from './index.module.less';

const ImageLine: FC<{values: Array<string>}> = ({ values }) => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <div className={styles.image} onClick={() => setVisible(true)}>
        <Image
          src={getQiniuOriginalUrl(values[0])}
          className={styles['image-icon']}
          preview={false}
        />
        <span className={styles['image-text']}>{values?.length || 0}张图片</span>
        <div className={styles.rightIconWrapper}>
          <IconFont iconHref='pc-common-icon-ic_arrow_right' className={styles.icon}/>
        </div>
      </div>

      <div style={{ display: 'none' }}>
        <Image.PreviewGroup preview={{ visible, onVisibleChange: vis => setVisible(vis) }}>
          {
            values?.map((imgItem: any, index: any) =>
              <Image src={imgItem ? `${getQiniuOriginalUrl(imgItem)}` : ''} key={index}/>
            )
          }
        </Image.PreviewGroup>
      </div>

    </>
  );
};

export default ImageLine;
